import React from 'react'
import { TopSuppliers, StorageStatuses, SoldByChannels, SellsByTime, BottlesByStatus } from 'components/dashboard'
import { useStyles } from './content.css'

const Content = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <TopSuppliers />
      <StorageStatuses />
      <SellsByTime />
      <SoldByChannels />
      <BottlesByStatus />
    </div>
  )
}

export default Content